import { ROUTES } from '@/common/auth-routes';
import { FeatureFlag } from '@/enums/feature-flag';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

export function useHomeRoute() {
  const hasExternalSamlIdp = useFeatureFlag(FeatureFlag.EXTERNAL_SAML_IDP);

  return hasExternalSamlIdp ? ROUTES.AGENTS : ROUTES.DASHBOARD;
}
